import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadMassnahmeListStatus: 'idle',
    loadMassnahmeListError: undefined as any,
    loadMassnahmeListLastArgs: undefined as any,
    loadMassnahmeStatus: 'idle',
    loadMassnahmeError: undefined as any,
    saveMassnahmeStatus: 'idle',
    saveMassnahmeError: undefined as any,
    deleteMassnahmeStatus: 'idle',
    deleteMassnahmeError: undefined as any,

    massnahmeList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadMassnahmeList = createAsyncThunk('auftragMassnahmeSlice/loadMassnahmeList', async ({ parentModel, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragMassnahmeSlice.loadMassnahmeListLastArgs
    if (_.isEqual(lastArgs, { parentModel }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/massnahme/?action=gte&MIN_AUFTRAGID=${parentModel.HDR_ID}&MAX_AUFTRAGID=${parentModel.HDR_ID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { parentModel }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMassnahmeListStatus } = getState().auftragMassnahmeSlice
        return loadMassnahmeListStatus !== 'pending'
    }
})

export const loadMassnahme = createAsyncThunk('auftragMassnahmeSlice/loadMassnahme', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/massnahme/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMassnahmeStatus } = getState().auftragMassnahmeSlice
        return loadMassnahmeStatus !== 'pending'
    }
})

export const saveMassnahme = createAsyncThunk('auftragMassnahmeSlice/saveMassnahme', async ({ massnahme }: any, { rejectWithValue }: any) => {
    let promises = []
    if (massnahme?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/massnahme/${ massnahme?.HDR_ID }/`,
            prepareData(massnahme),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/massnahme/`,
            prepareData(massnahme),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveMassnahmeStatus } = getState().auftragMassnahmeSlice
        return saveMassnahmeStatus !== 'pending'
    }
})

export const deleteMassnahme = createAsyncThunk('auftragMassnahmeSlice/deleteMassnahme', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/massnahme/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteMassnahmeStatus } = getState().auftragMassnahmeSlice
        return deleteMassnahmeStatus !== 'pending'
    }
})

const MassnahmeSlice = createSlice({
    name: 'auftragMassnahmeSlice',
    initialState,
    reducers: {
        resetloadMassnahmeListError: (state) => {
            state.loadMassnahmeListError = undefined
        },
        resetloadMassnahme: (state) => {
            state.formItem = undefined
            state.loadMassnahmeError = undefined
        },
        resetloadMassnahmeError: (state) => {
            state.loadMassnahmeError = undefined
        },
        resetsaveMassnahme: (state) => {
            state.formItem = undefined
            state.saveMassnahmeError = undefined
        },
        resetsaveMassnahmeError: (state) => {
            state.saveMassnahmeError = undefined
        },
        resetdeleteMassnahmeError: (state) => {
            state.deleteMassnahmeError = undefined
        },
        removeFromMassnahmeListById: (state, action) => {
            state.massnahmeList = state.massnahmeList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromMassnahmeListByIds: (state, action) => {
            state.massnahmeList = state.massnahmeList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.massnahmeList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadMassnahmeListStatus = 'preloaded'
            state.loadMassnahmeListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.massnahmeList = []
            state.loadMassnahmeListStatus = 'idle'
            state.loadMassnahmeListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadMassnahmeList.pending, (state) => {
            state.loadMassnahmeListStatus = 'pending'
            state.loadMassnahmeListError = undefined
        })
        builder.addCase(loadMassnahmeList.fulfilled, (state, action) => {
            state.loadMassnahmeListStatus = 'idle'

            if (!action.payload) { return }

            state.loadMassnahmeListLastArgs = action.payload.args

            {
                state.massnahmeList = action.payload.data

            }
        })
        builder.addCase(loadMassnahmeList.rejected, (state, action) => {
            state.loadMassnahmeListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMassnahmeListError = action.error.message
            } else {
                state.loadMassnahmeListError = action.payload
            }
        })

        builder.addCase(loadMassnahme.pending, (state) => {
            state.loadMassnahmeStatus = 'pending'
            state.loadMassnahmeError = undefined
        })
        builder.addCase(loadMassnahme.fulfilled, (state, action) => {
            state.loadMassnahmeStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.massnahmeList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.massnahmeList.push(newItem) }
                else { state.massnahmeList[i] = { ...state.massnahmeList[i], ...newItem } }
            }
        })
        builder.addCase(loadMassnahme.rejected, (state, action) => {
            state.loadMassnahmeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMassnahmeError = action.error.message
            } else {
                state.loadMassnahmeError = action.payload
            }
        })

        builder.addCase(saveMassnahme.pending, (state) => {
            state.saveMassnahmeStatus = 'pending'
            state.saveMassnahmeError = undefined
        })
        builder.addCase(saveMassnahme.fulfilled, (state, action) => {
            state.saveMassnahmeStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.massnahmeList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.massnahmeList.push(newItem) }
                else { state.massnahmeList[i] = { ...state.massnahmeList[i], ...newItem } }
            }
        })
        builder.addCase(saveMassnahme.rejected, (state, action) => {
            state.saveMassnahmeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveMassnahmeError = action.error.message
            } else {
                state.saveMassnahmeError = action.payload
            }
        })

        builder.addCase(deleteMassnahme.pending, (state) => {
            state.deleteMassnahmeStatus = 'pending'
            state.deleteMassnahmeError = undefined
        })
        builder.addCase(deleteMassnahme.fulfilled, (state, action) => {
            state.deleteMassnahmeStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.massnahmeList = state.massnahmeList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.massnahmeList = state.massnahmeList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteMassnahme.rejected, (state, action) => {
            state.deleteMassnahmeStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMassnahmeError = action.error.message
            } else {
                state.deleteMassnahmeError = action.payload
            }
        })

    }
})

export const {
    resetloadMassnahmeListError,
    resetloadMassnahme,
    resetloadMassnahmeError,
    resetsaveMassnahme,
    resetsaveMassnahmeError,
    resetdeleteMassnahmeError,
    removeFromMassnahmeListById,
    removeFromMassnahmeListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = MassnahmeSlice.actions
export default MassnahmeSlice.reducer
